module.exports = __webpack_public_path__ + "img/59.ea16a700.jpg";